"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["src", "srcset", "alt"];
const _hoisted_2 = { class: "w-14 flex-shrink-0 flex justify-center items-center font-extrabold text-2xl" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
    key: 1,
    class: "flex-auto py-2 pr-2"
};
const vue_3 = require("vue");
const AnswerType_1 = require("../../src/types/AnswerType");
const AnswerButton_vue_1 = __importDefault(require("./AnswerButton.vue"));
const AudioPlayer_vue_1 = __importDefault(require("../AudioPlayer.vue"));
const ProficiencyTest_1 = require("../../stores/ProficiencyTest");
const pinia_1 = require("pinia");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProficiencyTestAnswer',
    props: {
        answer: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    setup(__props) {
        const props = __props;
        const store = (0, ProficiencyTest_1.useProficiencyTestStore)();
        const { currentAnswer, answerSubmitted } = (0, pinia_1.storeToRefs)(store);
        const selected = (0, vue_3.computed)(() => {
            var _a;
            return ((_a = currentAnswer.value) === null || _a === void 0 ? void 0 : _a.id) === props.answer.id;
        });
        const wrapperClass = (0, vue_3.computed)(() => {
            if (!selected.value) {
                return '';
            }
            if (answerSubmitted.value) {
                if (props.answer.correct) {
                    return 'outline outline-2 outline-green-200';
                }
                else {
                    return 'outline outline-2 outline-red-500';
                }
            }
            return 'outline outline-2 outline-mutedpurple-800';
        });
        /**
         * Convert a number to an alphabet character, 0=A, 1=B etc.
         */
        function numberToAlphabet(number) {
            return (number + 10).toString(36).toUpperCase();
        }
        function selectAnswer() {
            if (!store.answerSubmitted) {
                store.currentAnswer = props.answer;
            }
        }
        return (_ctx, _cache) => {
            var _a, _b, _c;
            return (__props.answer.answer_type == (0, vue_2.unref)(AnswerType_1.AnswerType).Image)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                    key: 0,
                    class: "rounded relative",
                    onClick: selectAnswer
                }, [
                    (__props.answer.file)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("img", {
                            key: 0,
                            src: (_a = __props.answer.file.urls) === null || _a === void 0 ? void 0 : _a.size_16_9_200,
                            srcset: `${(_b = __props.answer.file.urls) === null || _b === void 0 ? void 0 : _b.size_16_9_200} 200w, ${(_c = __props.answer.file.urls) === null || _c === void 0 ? void 0 : _c.size_16_9_400} 400w`,
                            alt: __props.answer.file.alt_text,
                            class: "rounded-3xl"
                        }, null, 8, _hoisted_1))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createVNode)(AnswerButton_vue_1.default, {
                        answer: __props.answer,
                        answered: !!(0, vue_2.unref)(store).currentAnswer,
                        selected: (0, vue_2.unref)(selected),
                        onClick: selectAnswer,
                        class: "absolute bottom-0 right-0 h-[60px] w-[60px]",
                        type: "corner"
                    }, null, 8, ["answer", "answered", "selected"])
                ]))
                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                    key: 1,
                    class: (0, vue_2.normalizeClass)(["rounded-xl flex items-stretch bg-beige-100 col-span-2", (0, vue_2.unref)(wrapperClass)]),
                    onClick: selectAnswer
                }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)(numberToAlphabet(__props.index)) + ": ", 1),
                    (__props.answer.answer_type === (0, vue_2.unref)(AnswerType_1.AnswerType).Text || !__props.answer.file)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                            key: 0,
                            innerHTML: __props.answer.content,
                            class: "flex-auto py-4 pr-5 text-lg flex justify-start items-center"
                        }, null, 8, _hoisted_3))
                        : (__props.answer.answer_type === 'audio')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                (0, vue_2.createVNode)(AudioPlayer_vue_1.default, {
                                    src: __props.answer.file.url,
                                    class: "w-full h-10"
                                }, null, 8, ["src"])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createVNode)(AnswerButton_vue_1.default, {
                        answer: __props.answer,
                        answered: !!(0, vue_2.unref)(store).currentAnswer,
                        selected: (0, vue_2.unref)(selected),
                        onClick: selectAnswer,
                        type: "inline"
                    }, null, 8, ["answer", "answered", "selected"])
                ], 2));
        };
    }
});
